var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlameicon = function SvgFlameicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 9.117c1.944-2.756.14-6.519-.833-7.45 0 2.829-1.863 4.415-3.056 5.588-1.192 1.173-1.944 3.018-1.944 4.657 0 3.086 2.611 5.588 5.833 5.588s5.833-2.502 5.833-5.588c0-1.427-1.026-3.67-1.944-4.657-1.736 2.794-2.714 2.794-3.889 1.862"
  })));
};
export default SvgFlameicon;